export const contactLoanListGet = ({ $scope, contactService, familyId }) => {
  return contactService.loanListGet(familyId, false, true).then((response) => {
    $scope.loanList = response.data;
    $scope.separateExistingFromInProgressLoan($scope.loanList);
  });
};
